export default __webpack_public_path__ + "static/textAndImages_cloud_bottom-2d54f68fde78d7b7fbf761c6d25f23da.png";